var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLangIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.1046C13.4183 17.1046 17 13.4995 17 9.05231C17 4.60514 13.4183 1 9 1C4.58172 1 1 4.60514 1 9.05231C1 13.4995 4.58172 17.1046 9 17.1046Z",
    stroke: "#101728",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.05231H17",
    stroke: "#101728",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00005 17.1046C10.7674 17.1046 12.2 13.4995 12.2 9.05231C12.2 4.60514 10.7674 1 9.00005 1C7.23273 1 5.80005 4.60514 5.80005 9.05231C5.80005 13.4995 7.23273 17.1046 9.00005 17.1046Z",
    stroke: "#101728",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.34302 3.4729C4.79073 4.93009 6.79073 5.83138 8.99985 5.83138C11.209 5.83138 13.209 4.93009 14.6567 3.4729",
    stroke: "#101728",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6567 14.6317C13.209 13.1745 11.209 12.2732 8.99985 12.2732C6.79073 12.2732 4.79073 13.1745 3.34302 14.6317",
    stroke: "#101728",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangIcon);
export default __webpack_public_path__ + "static/media/lang-icon.1c94168e51dbbd069cbe501ce00d5d8a.svg";
export { ForwardRef as ReactComponent };